import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoaformComponent } from './loaform/loaform.component';
//import { SuccessformComponent } from './successform/successform.component';

const routes: Routes = [  
  { path: '', redirectTo: '/loaform', pathMatch: 'full' },
  { path: 'loaform', component: LoaformComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})



export class AppRoutingModule { }
